(function () {

  function initJptFloatingVideo(root) {

    if (!root || root.dataset.jptVideoInitialized === "true") {
      return;
    }

    var trigger = root.querySelector("[data-jpt-video-open]");
    var previewVideo = root.querySelector(
      ".jpt-floating-video__preview-video"
    );

    var modal = root.querySelector("[data-jpt-video-modal]");
    var player = root.querySelector("[data-jpt-video-player]");
    var template = root.querySelector("[data-jpt-video-template]");

    var closeButtons = root.querySelectorAll(
      "[data-jpt-video-close]"
    );

    if (!trigger || !modal || !player || !template) {
      return;
    }

    root.dataset.jptVideoInitialized = "true";

    var modalVideo = null;
    var previousFocus = null;


    /* -------------------------
       CREATE LARGE VIDEO
       ------------------------- */

    function mountVideo() {

      if (modalVideo) {
        return modalVideo;
      }

      var fragment = template.content.cloneNode(true);

      player.appendChild(fragment);

      modalVideo = player.querySelector("video");

      if (!modalVideo) {
        return null;
      }

      modalVideo.setAttribute("playsinline", "");
      modalVideo.setAttribute("controls", "");
      modalVideo.setAttribute("preload", "none");

      return modalVideo;
    }


    /* -------------------------
       OPEN
       ------------------------- */

    function openModal() {

      previousFocus = document.activeElement;

      if (previewVideo) {
        previewVideo.pause();
      }

      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");

      document.body.classList.add("jpt-video-open");

      var video = mountVideo();

      var closeButton = modal.querySelector(
        ".jpt-floating-video__close"
      );

      if (closeButton) {
        closeButton.focus();
      }

      if (video) {

        var playPromise = video.play();

        if (
          playPromise &&
          typeof playPromise.catch === "function"
        ) {
          playPromise.catch(function () {
            /* Native controls remain available */
          });
        }
      }
    }


    /* -------------------------
       CLOSE
       ------------------------- */

    function closeModal() {

      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");

      if (modalVideo) {
        modalVideo.pause();
      }

      /*
       Remove popup video completely.
       This prevents hidden video playback
       and releases unnecessary resources.
      */
      player.innerHTML = "";
      modalVideo = null;

      document.body.classList.remove("jpt-video-open");


      /* Resume floating muted preview */

      if (previewVideo) {

        var previewPromise = previewVideo.play();

        if (
          previewPromise &&
          typeof previewPromise.catch === "function"
        ) {
          previewPromise.catch(function () {});
        }
      }


      if (
        previousFocus &&
        typeof previousFocus.focus === "function"
      ) {
        previousFocus.focus();
      }
    }


    /* -------------------------
       EVENTS
       ------------------------- */

    trigger.addEventListener("click", openModal);


    closeButtons.forEach(function (button) {

      button.addEventListener("click", function () {
        closeModal();
      });

    });


    document.addEventListener("keydown", function (event) {

      if (!modal.classList.contains("is-open")) {
        return;
      }

      if (event.key === "Escape") {

        event.preventDefault();

        closeModal();
      }
    });

  }


  /* -------------------------
     INITIALIZE
     ------------------------- */

  function initAllJptVideos(scope) {

    var container = scope || document;

    container
      .querySelectorAll("[data-jpt-floating-video]")
      .forEach(function (element) {

        initJptFloatingVideo(element);

      });

  }


  if (document.readyState === "loading") {

    document.addEventListener(
      "DOMContentLoaded",
      function () {
        initAllJptVideos(document);
      }
    );

  } else {

    initAllJptVideos(document);

  }


  /*
   Shopify Theme Editor compatibility
  */

  document.addEventListener(
    "shopify:section:load",
    function (event) {

      initAllJptVideos(event.target);

    }
  );

})();